<div class="address">
  <div>{{ address }}</div>
  <i *ngIf="showOnMap" class="icon-navigation" (click)="openMap()"></i>
</div>
